import { render, staticRenderFns } from "./huoyunDetails.vue?vue&type=template&id=7982d150&scoped=true&"
import script from "./huoyunDetails.vue?vue&type=script&lang=js&"
export * from "./huoyunDetails.vue?vue&type=script&lang=js&"
import style0 from "./huoyunDetails.vue?vue&type=style&index=0&id=7982d150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7982d150",
  null
  
)

export default component.exports